import * as Constants from '../constants';
import { INITIAL_STAGES_STATE } from '../initial-state';

import { updateValueFieldsReducer } from './helpers';

const resetStagesReducer = (state) => {
  return { ...state, [Constants.FIELDS.STAGES]: INITIAL_STAGES_STATE };
};

export const STAGES_REDUCERS = {
  [Constants.ACTIONS.RESET_STAGES]: resetStagesReducer,
  [Constants.ACTIONS.UPDATE_STAGES_ERRORS]: updateValueFieldsReducer({
    storeField: Constants.FIELDS.STAGES,
    valueField: Constants.STAGES_VALUE_FIELDS.ERROR,
  }),
  [Constants.ACTIONS.UPDATE_STAGES_LOADINGS]: updateValueFieldsReducer({
    storeField: Constants.FIELDS.STAGES,
    valueField: Constants.STAGES_VALUE_FIELDS.LOADING,
  }),
};
